import apiClient from '@/api/client'

const url = 'https://get.geojs.io/v1/ip/geo.json'

export default {
  getIPLocation: async () => apiClient.get(url),
}
